import { Inject, Injectable } from '@angular/core';

import type { IAppConfig } from '@core/common-legacy';
import { APP_CONFIG, AUTH_TOKEN, COMPANY_ID } from '@core/common-legacy';
import { EmailProviders } from '@core/email-providers-types';
import { HttpApiService } from '@core/http-legacy';

@Injectable({ providedIn: 'root' })
export class EmailProvidersUrlService {
  constructor(
    protected httpApi: HttpApiService,
    @Inject(COMPANY_ID) private companyId: string,
    @Inject(AUTH_TOKEN) private token: string,
    @Inject(APP_CONFIG) private appConfig: IAppConfig,
  ) {}

  public googleConnectUrl(returnTo?: 'academy'): string {
    const queryParamString = this.paramsToQuerystring({
      // change to EmailProviders.Google after api names unify
      integration: 'gmail',
      returnTo,
    });

    return `${this.appConfig.authUrl}c/${this.httpApi.currentCompanyId}/integrations?${queryParamString}`;
  }

  public microsoftConnectUrl(returnTo?: 'academy', allowOnPremise?: boolean): string {
    const queryParamString = this.paramsToQuerystring({
      integration: EmailProviders.Microsoft,
      returnTo,
      ...(allowOnPremise ? { allowOnPremise } : {}),
    });

    return `${this.appConfig.authUrl}c/${this.httpApi.currentCompanyId}/integrations?${queryParamString}`;
  }

  private paramsToQuerystring(params: object) {
    return Object.entries(params)
      .filter(([key, value]) => value !== undefined)
      .map(entry => entry.join('='))
      .join('&');
  }
}
